import { useState, useEffect } from 'react'

function usePolling(func, interval, init = undefined, enabled = false) {
    const [value, setValue] = useState(init)

    useEffect(() => {
        if (!enabled) {
            return
        }

        const init = async () => {
            const response = await func()
            setValue(response)    
        }

        init()
        
        const start = Date.now()
        const intervalId = setInterval(async () => {
            if (Date.now() - start >= 3_600_000) {
                clearInterval(intervalId)
                return
            }
            const response = await func()
            setValue(response)
        }, interval)

        return () => {
            clearInterval(intervalId)
        }
    }, [func, interval, enabled])

    return value
}

export default usePolling